import * as React from "react";

const CustomerManagement = () => {
  return <div className="settingParent"></div>;
};
export default CustomerManagement;